import React, { useState, useEffect } from 'react';
import { useSelector } from 'react-redux';
import { RootState } from '../../store/index';
import { useCustomData } from '../../pages/context/serviceCustomDataProvider';

interface ServiceHomePart1eProps {
    handleViewChange: (newView: string, data?: any) => void;
    data?: any;
    onOpenModal?: (type: 'basic' | 'premium') => void;
    onOpenNote?: (type: 'basic' | 'premium') => void;
}

interface eInteriorData {
    exterior: string;
    interior: string;
}

const ServiceHomePart1: React.FC<ServiceHomePart1eProps> = ({ handleViewChange, data, onOpenModal, onOpenNote }) => {
    const themeColor = useSelector((state: RootState) => state.themeColor.value);
    const { customData } = useCustomData();
    const [interiorList, setInteriorList] = useState<eInteriorData[]>([]);


    useEffect(() => {
        const order = [
            'serviceBusinessOne',
            'serviceBusinessTwo',
            'serviceBusinessThree',
            'serviceBusinessFour',
            'serviceBusinessFive',
            'serviceBusinessSix',
            'serviceBusinessSeven',
            'serviceBusinessEight'
        ];


        const customList: eInteriorData[] = [];

        order.forEach(code => {
            const item = customData.find(d => d.code === code);
            if (item && typeof item.value === 'string') {
                if (item.value.includes('～')) {

                    const [exterior, interiorRaw] = item.value.split('～');
                    const interiorParts = interiorRaw
                        .split('|')
                        .map(part => `<p>${part.trim()}</p>`)
                        .join('');
                    customList.push({
                        exterior: exterior.trim(),
                        interior: interiorParts
                    });
                } else {
                    // 如果没有 ～ 分隔符，直接用 value 作为外部描述，内部为空
                    customList.push({
                        exterior: item.value.trim(),
                        interior: ''
                    });
                }
            }
        });
        setInteriorList(customList);
    }, [customData]);

    const goBack = () => {
        handleViewChange('service-index');
    };

    return (
        <div className='service-home-part1'>
            {interiorList.map((item, index) => (
                <div className='service-part1-item' style={{ background: themeColor }} key={index}>
                    <div className='item-exterior'>{item.exterior}</div>
                    <div className='item-interior' dangerouslySetInnerHTML={{ __html: item.interior }}></div>
                </div>
            ))}

        </div>
    )

};

export default ServiceHomePart1;
